import VueAnalytics, { event, set } from 'vue-analytics'
import * as R from 'ramda'
import { branchPlatform as bp, noop } from '@/libs/util'

let options = {}
const cfa = () => cordova.plugins.firebase.analytics

const Event = {
  SEARCH_BY_ELASTIC: 'search_by_elastic',
  SEARCH_BOOKS: 'search_books',
  FILTER_ITEMS: 'filter_items',
  SORT_ITEMS: 'sort_items',
  REMOVE_ITEM: 'remove_item',
  SCAN_BARCODE: 'scan_barcode',
  ADD_ITEM: 'add_item',
  UPDATE_ITEM: 'update_item',
  CLICK_PURCHASE: 'click_purchase',
  CLICK_UPGRADE_NOTICE: 'click_upgrade_notice',
  IMPORT_BY_SERVICE: 'import_by_service',
  UPDATE_BY_SERVICE: 'update_by_service',
  UNLINK_SERVICE: 'unlink_service',
  CONVERT_TO_TEXT: 'convert_to_text',
  EXPORT_NOTES: 'export_notes',
  SIGN_IN: 'sign_in',
  SIGN_UP: 'sign_up',
  LOGOUT: 'logout',
  DELETE_ACCOUNT: 'delete_account',
  FEEDBACK: 'feedback',
  CLICK_SHARE: 'click_share',
  CLICK_HIGHLIGHTING: 'click_highlighting',
  CLICK_NOTELISTS: 'click_notelists',
  CLICK_CHARTS: 'click_charts',
  CLICK_LINK_MANAGER: 'click_link_manager',
  CREATE_NOTELIST: 'create_notelist',
  DELETE_NOTELIST: 'delete_notelist',
  CREATE_LINK: 'create_link',
  DELETE_LINK: 'delete_link'
}

const debugNoop = (fn) => (...args) => options.deactivated ? noop() : fn(...args)

const FA = () => {
  return {
    logEvent (...args) {
      return bp({
        native: () => cfa().logEvent(...args),
        browser: debugNoop(() => {
          const category = args[0]
          const params = args[1]

          R.keys(params).forEach(key => {
            const val = params[key]

            if (R.is(Number)(val)) {
              event(category, key, null, val)
            } else {
              event(category, key, val)
            }
          })
        })
      })
    },
    setUserId (...args) {
      return bp({
        native: () => cfa().setUserId(...args),
        browser: debugNoop(() => {
          set('userId', ...args)
        })
      })
    },
    setEnabled (...args) {
      return bp({
        native: () => cfa().setEnabled(...args)
      })
    }
  }
}

const fa = FA()

export default {
  install (Vue, opts) {
    options = opts

    if (device.platform.toLowerCase() === 'browser' && !opts.deactivated) {
      Vue.use(VueAnalytics, opts.vueAnalytics)
    }

    if (!opts.vueAnalytics.debug.sendHitTask || opts.deactivated) {
      fa.setEnabled(false)
    }

    Vue.prototype.$fa = Object.assign(fa, { Event })
  }
}

export { fa }
